import { TooltipV2 } from '@cimplico/components';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';

type TaskCheckboxProps = {
    status: 'CHECKED' | 'UNCHECKED' | 'NOT_APPLICABLE';
    disabled: boolean;
    disabledHint?: string;
    onChange?: (status: 'CHECKED' | 'UNCHECKED' | 'NOT_APPLICABLE') => void;
};

export default function TaskCheckbox({ status, disabled, disabledHint, onChange }: TaskCheckboxProps): JSX.Element {
    return (
        <TooltipV2 message={disabledHint} disabled={!disabled || !disabledHint}>
            <div
                onClick={disabled ? undefined : (): void => onChange && onChange(status)}
                className={disabled ? '' : '[&>*]:cursor-pointer'}
            >
                {status === 'NOT_APPLICABLE' && <XCircleIcon className="w-5 h-5 text-red-500 fill-white" />}
                {status === 'CHECKED' && <CheckCircleIcon className="w-5 h-5 text-green-500 fill-white" />}
                {status === 'UNCHECKED' && (
                    <div className="w-4 h-4 rounded-full border-[1.5px] border-gray-300 flex items-center justify-center m-0.5 bg-white"></div>
                )}
            </div>
        </TooltipV2>
    );
}
